import { createComponent } from "@helpers/admin";
import BentoBoxGrid from "@template/blocks/BentoBoxGrid/component";

export const BentoBox = createComponent({
  label: "Bento Box",
  component: BentoBoxGrid,
  fields: {
    gap: {
      label: "Gap",
      type: "number",
      default: 12,
    },
    borderRadius: {
      label: "Border Radius",
      type: "number",
      default: 12,
    },
    items: {
      label: "Items",
      type: "array",
      arrayFields: {
        width: {
          label: "Width",
          type: "number",
          default: 8,
          placeholder: "1 - 16",
          min: 1,
          max: 12,
        },
        height: {
          label: "Height",
          type: "number",
          default: 1,
          min: 1,
        },
        heading: {
          label: "Heading",
          type: "textarea",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        image: {
          label: "Image",
          type: "image",
        },
        reverse: {
          label: "Reverse",
          type: "boolean",
        },
        cta: {
          label: "CTA",
          type: "object",
          objectFields: {
            text: {
              label: "Text",
              type: "text",
            },
            href: {
              label: "Href",
              type: "text",
            },
            target: {
              label: "Open In New Tab",
              type: "select",
              options: [
                {
                  label: "Yes",
                  value: "_blank",
                },
                { label: "No", value: "_self" },
              ],
            },
          },
        },
        button: {
          label: "Button",
          type: "button",
        },
        alternativeStyling: {
          label: "Alternative Styling",
          type: "boolean",
        },
      },
    },
  },
});
